import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import * as serviceWorker from "./serviceWorker";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Adcodes from "assets/json/adcode.json";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route
          path="/"
          render={({ location }) => {
            const mapName =
              (new URLSearchParams(location.search).get(
                "mapName"
              ) as keyof typeof Adcodes) || "全国";
            if (!Adcodes[mapName]) {
              return <Redirect to="/" />;
            }
            return <App />;
          }}
        ></Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
